import {numericCompareDesc} from '@lib/utils';
import {LocationNode} from '../../ui';

export const compareWorkdayBySortingOrder = (
  sortingOrder: (string | undefined)[],
  a: LocationNode,
  b: LocationNode,
) => {
  const indexA = sortingOrder.indexOf(a.id ?? a.type);
  const indexB = sortingOrder.indexOf(b.id ?? b.type);

  return numericCompareDesc(indexA, indexB);
};
